import { createSelector } from '@reduxjs/toolkit'
import _find from 'lodash/find'
import _first from 'lodash/first'
import _orderBy from 'lodash/orderBy'

import { TaxConsultation } from '@/models/tax-consultation'
import { RootState } from '@/store'

export const getTaxConsultationsSlice = (state: RootState) => state.taxConsultations

export const getTaxConsultationsRequestStatus = createSelector([getTaxConsultationsSlice], (taxConsultations) => ({
    isFetchSuccessful: taxConsultations.fetchSuccessful,
    isFetching: taxConsultations.isFetching,
}))

const pluckTaxConsultationId = (_: unknown, { taxConsultationId }: { taxConsultationId: TaxConsultation['id'] }) =>
    taxConsultationId

export const getTaxConsultations = createSelector([getTaxConsultationsSlice], ({ items }) =>
    _orderBy(items, 'id', 'desc')
)

export const getLatestTaxConsultation = createSelector([getTaxConsultations], (taxConsultations) =>
    _first(taxConsultations)
)

export const getTaxConsultationById = createSelector(
    [getTaxConsultations, pluckTaxConsultationId],
    (taxConsultations, id) => _find(taxConsultations, { id })
)

const getTaxConsultationAgreements = (state: RootState) => state.taxConsultations.agreements

export const getTaxConsultationAgreementById = createSelector(
    [getTaxConsultationAgreements, pluckTaxConsultationId],
    (agreements, taxConsultationId) => _find(agreements, { taxConsultationId })
)
